import React from 'react';
import styled from 'styled-components';
import Icon from '../elements/Icon';
import Theme from '../modules/Theme';
import TooltipTrigger from '../elements/TooltipTrigger';
import { textMuted, ellipsis } from '../modules/Styles';
export var iconWidth = 106;
var Wrapper = styled.div.withConfig({
  displayName: "CardFooterIcon__Wrapper",
  componentId: "jpidwj-0"
})(["display:inline-block;text-align:center;", " ", "{display:block;width:100%;color:", ";}width:", "px;&:last-child{margin-right:0;}"], ellipsis(), Icon, Theme.primaryDark, iconWidth);
var Text = styled.span.withConfig({
  displayName: "CardFooterIcon__Text",
  componentId: "jpidwj-1"
})(["", ""], textMuted());

var CardFooterIcon = function CardFooterIcon(_ref) {
  var className = _ref.className,
      name = _ref.name,
      src = _ref.src,
      text = _ref.text,
      tooltip = _ref.tooltip;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(TooltipTrigger, {
    tooltip: tooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    fixedWidth: true,
    name: name,
    size: "2x",
    src: src
  }), /*#__PURE__*/React.createElement(Text, null, text)));
};

export default CardFooterIcon;